const expiryDate = (expiry) => {
  const dt = new Date();

  dt.setTime(dt.getTime() + expiry);

  return dt.toUTCString();
};

export const setCookie = (cookieName, cookieValue, cookiePath = '/', expiry = null) => {
  const sameSiteNoneSecure = window.location.protocol === 'https:' ? 'samesite=none; secure;' : '';

  const expiryValue = expiry
    ? `expires=${expiryDate(expiry)};`
    : '';

  document.cookie = `${cookieName}=${cookieValue}; ${sameSiteNoneSecure} ${expiryValue} path=${cookiePath}`;
};

export const getCookie = (cookieName) => {
  const cookie = document.cookie.split('; ').find((c) => (c.startsWith(`${cookieName}=`)));

  if (cookie === undefined) return null;

  return cookie.replace(`${cookieName}=`, '');
};

export const removeCookie = (cookieName) => {
  document.cookie = `${cookieName}=0; path=/; max-age=0`;
};
